/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.triggerGeofence.internal

import features.triggerGeofence.models.TriggerGeofenceRequest
import features.triggerGeofence.models.TriggerGeofenceResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.triggerGeofence.internal.TriggerGeofencesUseCase.Params

internal class TriggerGeofencesUseCase : AsyncUseCase<TriggerGeofenceResponseModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val triggerGeofenceRequest: TriggerGeofenceRequest
    )

    private val triggerGeofencesService: TriggerGeofencesService = TriggerGeofencesServiceImpl()

    override suspend fun run(params: Params): Result<TriggerGeofenceResponseModel> {
        return triggerGeofencesService.triggerGeofence(
            overrideHeaders = params.overrideHeaders,
            triggerGeofenceRequest = params.triggerGeofenceRequest
        )
    }
}
